import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showAlert"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setSuccessAlert, setAlert } from 'actions/alerts';
import userCalendarKeys from './queryKeys';
export function useDisconnectMyCalendar() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$showAlert = _ref.showAlert,
    showAlert = _ref$showAlert === void 0 ? true : _ref$showAlert,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function disconnectMyCalendar(_x) {
    return _disconnectMyCalendar.apply(this, arguments);
  }
  function _disconnectMyCalendar() {
    _disconnectMyCalendar = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('delete', "/api/me/calendar/".concat(provider, "/auth"), null));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _disconnectMyCalendar.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: disconnectMyCalendar
    }, options), {}, {
      onSuccess: function onSuccess() {
        if (showAlert) {
          setSuccessAlert({
            title: t('alert_calendar_disconnect_success')
          });
        }
        queryClient.invalidateQueries({
          queryKey: userCalendarKeys.userCalendar
        });
      },
      onError: function onError() {
        if (showAlert) {
          setAlert({
            title: t('alert_calendar_disconnect_error')
          });
        }
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    isLoading: result.isPending,
    disconnectMyCalendar: mutateAsync
  });
}